export default __webpack_public_path__ + "static/media/Sani-Matic.8d1289f6.png";